import { ConsolidatedImpact } from "../components/ConsolidatedImpact";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import api from "../lib/api";
import TestimonialsSlider from "../components/TestimonialsSlider";
import { ImpactStories } from "../components/ImpactStories";

export default function Impact() {
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    document.title = "Impact | Dutsen Kauna Foundation";
    api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="impact-page">
      <section className="relative bg-[#155e3f] text-white py-24 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1586900632557-b99cf3b226cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMHdhdGVyJTIwcHVtcCUyMHZpbGxhZ2V8ZW58MHx8fHwxNzgyNjA5NTUzfDA&ixlib=rb-4.1.0&q=85" alt="Families receiving food support from Foundation volunteers" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#155e3f] via-[#155e3f]/85 to-[#155e3f]/40" />
        <div className="dk-container relative">
          <span className="text-[#d6aa43] tracking-[0.3em] text-xs font-semibold uppercase">Our impact</span>
          <h1 className="font-serif text-4xl md:text-6xl font-bold mt-3 max-w-3xl">Numbers, faces, and real change.</h1>
          <Link to="/impact-map" className="dk-btn-outline mt-8 inline-flex" data-testid="impact-map-cta"><MapPin size={16} /> Explore the impact map</Link>
        </div>
      </section>
      <ConsolidatedImpact />
      <div id="stories"><ImpactStories /></div>
      <TestimonialsSlider items={testimonials} />
    </div>
  );
}
